// tslint:disable
import * as React from 'react';
import { SidebarHeaderComponent, SidebarItemComponent } from '../../components/structurals/sidebar/sidebar-item.component';

declare const $: any;

export class DefaultSidebar extends React.Component<any, any> {

    public state: any= {
        currentPage:''
    }

    componentDidMount() {
        $('li').has('.sidebar-submenu').click(function (e: any) {
            $('.sfHover').children('.sidebar-submenu').toggle();
            $('.sfHover').removeClass('sfHover');
            $(e.currentTarget).children('.sidebar-submenu').toggle();
            $(e.currentTarget).toggleClass('sfHover');

        });
        // console.log(window.location.pathname)
    }
 

    render() {
        return (
            <div id="page-sidebar" className="main-animated sidebar main-sidebar">
                <div className="scroll-sidebar">
                    <ul id="sidebar-menu">

                        <SidebarItemComponent link="#" icon="fa-dashboard" title="Admin Dashboard"/>

                        <SidebarItemComponent link="sd/edit" icon="fa-building" title="Site details"/>
                        <SidebarItemComponent link="member" icon="fa-users" title="Members"/>
                        <SidebarItemComponent link="form" icon="fa-wpforms" title="Forms"/>
                        <SidebarItemComponent link="main-carousel" icon="fa-th-large" title="Main Carousel" badge="ASP"/>

                        <SidebarHeaderComponent title="ATAS"/>


                        <SidebarItemComponent link="enquiry" icon="fa-info-circle" title="Enquiry" badge="ATAS"/>
                        <SidebarItemComponent link="atas-training" icon="fa-lightbulb-o" title="Training" badge="ATAS"/>


                        <SidebarHeaderComponent title="Media"/>

                            <SidebarItemComponent link="file-manager" title="Media Manager" icon="fa-file-image-o"/>
                            <SidebarItemComponent link="media-album" title="Media Albums" icon="fa-image"/>

                        <SidebarItemComponent icon="fa-cogs" title="Media settings">
                            <SidebarItemComponent link="media-tag" title="Media Tags"/>
                            <SidebarItemComponent link="media-category" title="Media Categories"/>
                        </SidebarItemComponent>


                        <SidebarHeaderComponent title="Contents"/>
                        <SidebarItemComponent link="page" icon="fa-file-text" title="Page"/>

                        <SidebarHeaderComponent title="Articles"/>
                        <SidebarItemComponent icon="fa-newspaper-o" link="article" title="Articles"/>
                        <SidebarItemComponent icon="fa-map-signs" link="article-destination" title="Article Destination"/>
                        <SidebarItemComponent icon="fa-pencil-square-o" link="article-review" title="Article Review"/>

                        <SidebarItemComponent icon="fa-cogs"  title="Article settings">
                            <SidebarItemComponent link="article-category" title="Categories"/>
                            <SidebarItemComponent link="article-tag" title="Tags"/>
                            <SidebarItemComponent link="article-holiday-type" title="Holiday types"/>
                        </SidebarItemComponent>

                        <SidebarHeaderComponent title="Benefits"/>
                        <SidebarItemComponent icon="fa-thumbs-up" link="benefit" title="Benefits"/>
                        <SidebarItemComponent icon="fa-rocket" link="point" title="Points"/>

                        <SidebarItemComponent icon="fa-cogs"  title="Benefit settings">
                            <SidebarItemComponent link="benefit-category" title="Benefit categories"/>
                            <SidebarItemComponent link="benefit-membership-level" title="Benefit membership level"/>
                            <SidebarItemComponent link="benefit-discount" title="Benefit discount"/>
                            <SidebarItemComponent link="benefit-type" title="Benefit type"/>
                            <SidebarItemComponent link="point-reason" title="Point Reasons"/>
                        </SidebarItemComponent>


                        <SidebarHeaderComponent title="Bookings"/>
                        <SidebarItemComponent icon="fa-suitcase" link="booking" title="Bookings"/>

                        <SidebarItemComponent icon="fa-cogs"  title="Booking settings">
                            <SidebarItemComponent link="car-hire" title="Car hire"/>
                            <SidebarItemComponent link="airline" title="Airline"/>
                            <SidebarItemComponent link="holiday-type" title="Holdiay types"/>
                            <SidebarItemComponent link="tour-operator" title="Tour operators"/>
                        </SidebarItemComponent>

                        <SidebarHeaderComponent title="Event"/>
                        <SidebarItemComponent icon="fa-calendar" link="event" title="Events"/>
                        <SidebarItemComponent icon="fa-cogs"  title="Event settings">
                            <SidebarItemComponent link="event-place" title="Places"/>
                            <SidebarItemComponent link="event-category" title="Categories"/>
                            <SidebarItemComponent link="guest-type" title="Guest types"/>
                            <SidebarItemComponent link="period" title="Event Periods"/>
                            <SidebarItemComponent link="event-contact-type" title="Contact Types"/>
                        </SidebarItemComponent>

                        <SidebarHeaderComponent title="Issues"/>
                        <SidebarItemComponent icon="fa-book" link="issue" title="Issues" badge="Aspire"/>


                        <SidebarHeaderComponent title="Company"/>

                        <SidebarItemComponent icon="fa-building-o" title="Company" badge="GLOBAL">
                            <SidebarItemComponent link="company" title="Companies"/>
                            <SidebarItemComponent link="team-member" title="Team members"/>

                            <SidebarItemComponent link="company-admin" title="Admins"/>
                            <SidebarItemComponent link="faq" title="FAQs"/>
                        </SidebarItemComponent>

                        <SidebarItemComponent icon="fa-files-o" title="Company Contents">
                            <SidebarItemComponent link="company-page" title="Pages"/>
                            <SidebarItemComponent link="company-article" title="Articles"/>
                        </SidebarItemComponent>

                        <SidebarItemComponent icon="fa-cogs" title="Company settings">
                            <SidebarItemComponent link="job" title="Jobs"/>
                            <SidebarItemComponent link="membership-type" title="Membership types"/>
                            <SidebarItemComponent link="business-type" title="Business types"/>
                            <SidebarItemComponent link="turnover" title="Turnover"/>
                            <SidebarItemComponent link="company-page-type" title="Company-Page Types"/>
                        </SidebarItemComponent>

                        <SidebarHeaderComponent title="User & Person"/>
                        <SidebarItemComponent link="user" icon="fa-users" title="Users"/>
                        <SidebarItemComponent link="person" icon="fa-user-o" title="Persons"/>
                        <SidebarItemComponent link="person-company" icon="fa-user-circle-o" title="Person-Company"/>

                        <SidebarHeaderComponent title="Others"/>
                        <SidebarItemComponent link="contact" icon="fa-envelope-o" title="Contact"/>

                        <SidebarHeaderComponent title="Settings"/>
                        <SidebarItemComponent icon="fa-map-signs" title="Location">
                            <SidebarItemComponent link="city" title="Cities"/>
                            <SidebarItemComponent link="country" title="Countries"/>
                        </SidebarItemComponent>

                        <SidebarItemComponent link="mail-template" title="Mail templates" icon="fa-envelope"/>


                        <SidebarHeaderComponent title="E-learning"/>
                        <SidebarItemComponent link="e-learning-translations" title="Translations" icon="fa-language"/>
                    </ul>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/sidebar/default.sidebar.tsx